import './bootstrap';

// Importa o Font Awesome


// Configura o token CSRF para todas as requisições AJAX
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
});

$(document).ready(function () {



});